import { inject, Injectable } from '@angular/core';
import { LivrablePrincipal } from '@shared/models/livrable-principal.enum';

import { UserStore } from '../../auth/store/user.store';
import { Cartographie } from '../../cartographie/models/cartographie.model';
import { Référentiel } from '../../administration/gestion-référentiels/models/référentiel.model';
import { EstVerrouilleService } from './est-verrouille.service';

@Injectable({
  providedIn: 'root',
})
export class CanEditService {
  #userStore = inject(UserStore);
  #estVerrouilleService = inject(EstVerrouilleService);

  check(
    equipeResponsable: string | undefined,
    roles: string[],
    nomLivrable: LivrablePrincipal,
    cartographie: Cartographie,
    référentiel: Référentiel | null,
  ): boolean {
    const userStore = this.#userStore;
    const userRoles = userStore.roles();

    if (userStore.isAdmin()) return true;
    if (!equipeResponsable) return true;

    const estVerrouillé = this.#estVerrouilleService.check(nomLivrable, cartographie, référentiel);

    if (estVerrouillé) return false;

    return userRoles.includes(equipeResponsable) && userRoles.some((x) => roles.includes(x)) && !estVerrouillé;
  }
}
